import List from './List/List';
import Grid from './Grid/Grid';
import Table from './Table/Table';
import Compact from './Compact/Compact';
import Columns from './Columns/Columns';
import Directory from './Directory/Directory';

const templates = {
  List,
  Grid,
  Table,
  Compact,
  Columns,
  Directory,
};

export default templates;